import { takeEvery, put } from "redux-saga/effects";
import { PRODUCT_LIST, SET_PRODUCT_LIST } from "../constants";

// Worker saga to fetch products from the API
function* getProducts() {
  try {
    const data = yield fetch("https://fakestoreapi.com/products").then((res) =>
      res.json()
    );
    yield put({ type: SET_PRODUCT_LIST, data });
  } catch (error) {
    console.error("Failed to fetch products", error);
    yield put({ type: SET_PRODUCT_LIST, data: [] });
  }
}

// Watcher saga to listen for PRODUCT_LIST action
function* productSaga() {
  yield takeEvery(PRODUCT_LIST, getProducts);
}

export default productSaga;
